export default __webpack_public_path__ + "935eca18a9ead92923e223f59016bfc2.png";